import type { FunctionComponent } from 'react';

import { Anchor, Flex } from '@mantine/core';
import { useTranslation } from 'i18n';

const NS = 'footer';

const CPRA_LINK =
  'https://chownow-requests.my.onetrust.com/webform/67994022-0d2e-4da4-af0f-30b990afab7a/b16058fc-4ca6-4d7a-a18d-d18b292f7d11';

type FooterProps = {
  /** Horizontal alignment of the links. */
  align?: 'left' | 'center';
};

export const Footer: FunctionComponent<FooterProps> = ({ align = 'left' }) => {
  const { t } = useTranslation(NS, { useSuspense: false });
  const isCentered = align === 'center';

  return (
    <Flex
      component="footer"
      align={{ base: 'center', md: isCentered ? 'center' : 'flex-end' }}
      justify={isCentered ? 'center' : undefined}
      direction={{ base: 'column', md: 'row' }}
      gap={{ base: 'sm', md: 'md' }}
      p={{
        base: 'var(--mantine-spacing-md) var(--mantine-spacing-sm)',
        md: isCentered
          ? 'var(--mantine-spacing-md)'
          : 'var(--mantine-spacing-md) var(--mantine-spacing-xl)',
      }}
    >
      <Anchor
        data-testid="footer-do-not-share"
        underline="never"
        size="xs"
        href={CPRA_LINK}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('Footer.doNotSellOrShare')}
      </Anchor>
      <Anchor
        data-testid="footer-limit-use"
        underline="never"
        size="xs"
        href={CPRA_LINK}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('Footer.limitUse')}
      </Anchor>
    </Flex>
  );
};
